export const antThemeConfig = {
  token: {
    colorPrimary: '#F57423',
  },
};